<template>
  <div class="tabCard" @click="provisionalSelection = {}">
    <div class="title">
      选择角色
      <span>
        （请点击选择命座）
      </span>
    </div>
    <div class="options">
      <div class="list">
        <div class="option" v-for="(item,index) in optionsList" :key="index" @click.stop="optionClick(item)"  @dblclick.stop="dblclick(item)"
             :class="{'optionSelected':checked.findIndex(val => val.id === item.id) > -1}">
          {{item.name}}
          <div class="secOptions" v-show="item === provisionalSelection">
            <div class="label">
              请选择（单选）
            </div>
            <div class="secList">
              <div class="secOption" :class="{'secOptionSelected':checked.findIndex(val => val.id === item.id && val.sec_id === items.sec_id) > -1 }"
                   v-for="(items,indexs) in secOptions" :key="indexs"  @click.stop="secOptionClick(item,items)">
                {{items.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="selected">
      <div class="label">
        已选角色：
      </div>
      <div class="text">
        <span v-for="(item,index) in checked" :key="index">{{item.name}} x {{item.sec_name}} {{index+1 == checked.length?'':'/ '}}</span>
      </div>

    </div>
    <div class="num">
      <div class="label">
        黄数：
      </div>
      <div class="text">
        {{ roleTotal }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "tabCard",
  props:{
    optionsList:{
      type:Array,
      default:()=> []
    }
  },
  components:{},
  data(){
    return {
      secOptions:[
        {sec_id:'0',name:'0命'},
        {sec_id:'1',name:'1命'},
        {sec_id:'2',name:'2命'},
        {sec_id:'3',name:'3命'},
        {sec_id:'4',name:'4命'},
        {sec_id:'5',name:'5命'},
        {sec_id:'6',name:'6命'},
      ],
      //选中项
      checked:[],
      //临时选中
      provisionalSelection:{},
      clickOut:null,
      roleTotal:0
    }
  },
  methods:{
    /**
     * 选项点击事件
     * @param item
     */
    optionClick(item){
      clearTimeout(this.clickOut); //清除未执行的定时器
      this.clickOut = setTimeout( ()=>{
        this.provisionalSelection = item
      }, 200);
    },
    /**
     * 二级选项点击事件
     * @param item
     */
    secOptionClick(item,items){
      let obj = {
        id:this.provisionalSelection.id,
        name:item.name,
        sec_id:items.sec_id,
        sec_name:items.name,
        sort:item.sort
      }
      if (this.checked.findIndex(val => val.id === obj.id) === -1 ) {
        this.checked.push(obj)
      }else{
        if (this.checked[this.checked.findIndex(val => val.id === obj.id)].id == obj.id && this.checked[this.checked.findIndex(val => val.id === obj.id)].sec_id == obj.sec_id)   {
          this.checked.splice(this.checked.findIndex(val => val.id === obj.id),1)
        }else{
          this.checked[this.checked.findIndex(val => val.id === obj.id)] = obj
        }
      }
      this.sortAry()
      this.provisionalSelection = {}
      this.$emit('change',this.checked)
      this.calculateTheTotal()
    },

    /**
     * 双击取消选中
     * @param item
     */
    dblclick(item){
      clearTimeout(this.clickOut);
      if (this.checked.findIndex(val => val.id === item.id) > -1) {
        this.checked.splice(this.checked.findIndex(val => val.id === item.id),1)
        this.sortAry()
        this.$emit('change',this.checked)
        this.calculateTheTotal()
      }
    },
    /**
     * 计算角色数量
     */
    calculateTheTotal(){
      let total = 0
      for (let checkedElement of this.checked) {
        total = total + ((1 * checkedElement.sec_id) + 1)
      }
      this.roleTotal = total
    },
    /**
     * 排序
     */
    sortAry(){
      this.checked.sort(function(a,b){
        return a.sort - b.sort;
      })
      this.checked.sort(function(a,b){
        return b.sec_id * 1 - a.sec_id * 1;
      })
    }
  },
  watch:{
  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped lang="less">
.tabCard{
  border: 1px solid var(--border-soft, #E8E4DE);
  width: 889px;
  border-radius: 4px;
  margin: 0 0 0 120px;
  .title{
    padding: 20px 0 21px 30px;
    border-bottom: 1px solid #D7D7D7;
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #5B5B5B;
    span{
      margin: 0 0 0 2px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #5B5B5B;
    }
  }
  .options{
    border-bottom: 1px solid #D7D7D7;
    padding: 20px 0 0 34px;
    .list{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .option{
        border: 1px solid #F7F8F9;
        position: relative;
        width: 198px;
        height: 34px;
        background: #F7F8F9;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #929292;
        line-height: 34px;
        text-align: center;
        margin: 0 8px 10px 0;
        cursor: pointer;
        .secOptions{
          top: 37px;
          z-index: 999;
          position: absolute;
          width: calc(200px - 36px);
          background: #FFFFFF;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #ECECEC;
          padding: 9px 18px 15px;
          .label{
            color: #929292 !important;
            margin: 0 0 5px 0;
          }
          .secList{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .secOption{
              width: 70px;
              height: 24px;
              background: #F7F8F9;
              border-radius: 4px 4px 4px 4px;
              margin: 4px;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #929292;
              line-height: 24px;
              text-align: center;
            }
            .secOptionSelected{
              background: var(--primary-soft, #FCEDE5);
              color: var(--primary, #FF5A1F);
            }
          }
        }
      }
      .option:hover{
        border: 1px solid var(--primary, #FF5A1F);
      }
      .optionSelected{
        background: var(--primary-soft, #FCEDE5);
        border: 1px solid var(--primary, #FF5A1F);
        color: var(--primary, #FF5A1F) !important;
        .list{
          .option{
            color: var(--primary, #FF5A1F) !important;
          }
        }
      }

    }
  }

  .selected,.num{
    display: flex;
    align-items: baseline;
    padding: 20px 34px;
    .label{
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      margin: 0 5px 0 0;
      flex-shrink: 0;
    }
    .text{
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #606266;
      line-height: 20px;
    }

  }
  .selected{
    border-bottom: 1px solid #D7D7D7;
  }


}

</style>
